import {
  isEmailAddressProfessional,
  isPotentiallyLogisticsCompany,
} from "@/Shared/Authentication/Validators/authenticationCreateAccountValidators";

interface AccountCreatedConversionParams {
  email: string;
  phoneNumber: string;
  companyName: string;
  shipmentFrequency: string | undefined;
  isBusinessAccount: boolean;
  // Passed in rather than imported: both come from hooks the caller already holds.
  onAccountCreatedGoogle: (
    shipmentFrequency: string | undefined,
    email: string,
    phoneNumber: string,
  ) => void;
  onAccountCreatedOpenAi: (
    shipmentFrequency: string | undefined,
    email: string,
  ) => Promise<void>;
}

/**
 * Reports a signup to the ad platforms — but only for the kind of signup worth
 * paying for.
 *
 * Four exclusions, each there because counting it would distort what the ad
 * spend looks like it bought: a single shipment isn't a customer, a personal
 * email address usually isn't a business, a logistics company is a competitor
 * rather than a shipper, and a non-business account isn't the ICP.
 */
export function fireAccountCreatedConversion(
  params: AccountCreatedConversionParams,
) {
  const { email, phoneNumber, companyName, shipmentFrequency } = params;

  const isProfessionalEmail = isEmailAddressProfessional(email);
  const isLogisticsCompany = isPotentiallyLogisticsCompany(companyName);

  if (
    shipmentFrequency !== "SingleShipment" &&
    isProfessionalEmail &&
    !isLogisticsCompany &&
    params.isBusinessAccount
  ) {
    // Fire Account Created conversion (Secondary - for funnel visibility)
    params.onAccountCreatedGoogle(shipmentFrequency, email, phoneNumber);
    void params.onAccountCreatedOpenAi(shipmentFrequency, email);
  }
}
